module.exports = __webpack_public_path__ + "static/assets/1d9a284a53c8e0f10859033b42c6975e.svg";